export default __webpack_public_path__ + "static/media/2.6b608dd7.jpg";